export default "__VITE_ASSET__069c2cdf__"